exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "a._19hzBhB3VKV8hNMhY4l4om,a._19hzBhB3VKV8hNMhY4l4om:visited{color:#333}@media screen and (max-width: 500px){.gnmuC0mD9nKLYNjUHcqO7{display:none !important}}\n", ""]);

// Exports
exports.locals = {
	"authorLink": "_19hzBhB3VKV8hNMhY4l4om",
	"collapse": "gnmuC0mD9nKLYNjUHcqO7"
};